import { Inject, Injectable, Optional } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SIDEBAR_ITEMS } from '../config/menu.config';
import { selectUser } from '../store/auth/auth.selectors';
import { SidebarSection } from '../store/models/sidebar-section.model';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor(
    private _store: Store,
    private _permissionsService: PermissionsService,
    @Optional() @Inject(SIDEBAR_ITEMS) private _allItems: SidebarSection[]
  ) {
    if (!this._allItems) {
      this._allItems = [];
      console.warn(
        'No sidebar items provided for the application. Use the SIDEBAR_ITEMS injection token.'
      );
    }
  }

  /**
   * Returns the sidebar items filtered by the current user's permissions.
   * Items without `permissions` (or with an empty array) are always visible.
   * Sections with no visible items are hidden entirely.
   */
  getFilteredItemsForCurrentUser(): Observable<SidebarSection[]> {
    return this._store.pipe(
      select(selectUser),
      map((user) => {
        if (!user) {
          return [];
        }
        return this._allItems
          .map((section) => ({
            ...section,
            items: section.items.filter((item) =>
              this._permissionsService.hasPermissions(item.permissions ?? [])
            ),
          }))
          .filter((section) => section.items.length > 0);
      })
    );
  }
}
